function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || window.themeVariables.settings.moneyFormat;
  
  function defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."),
      dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      ),
      centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }

  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

function print() {
  const currencyFormat = window.themeVariables.settings.currencyCodeEnabled
    ? window.themeVariables.settings.moneyWithCurrencyFormat
    : window.themeVariables.settings.moneyFormat;

  // Get the subscription price and remove non-numeric characters
  var subscriptionprice = $(".subscription-radio .price-label").html();
  var numericPrice = parseFloat(subscriptionprice.replace(/[^0-9.]/g, ''));

  // Convert subscription price from cents to euros (if needed)
  numericPrice = numericPrice / 100;

  // Get the default compare price from a custom attribute and convert from cents to euros
  var compareprice = $(".get-price-default").attr("customprice");
  compareprice = parseFloat(compareprice) / 100;

  // Calculate the save price (difference between compare price and subscription price)
  var saveprice = compareprice - numericPrice;

  // Format the subscription, compare, and save prices using the formatMoney function
  var formattedSubscriptionPrice = formatMoney(numericPrice * 100, currencyFormat); // Multiply by 100 to handle cents
  var formattedComparePrice = formatMoney(compareprice * 100, currencyFormat); // Multiply by 100 to handle cents
  var formattedSavePrice = formatMoney(saveprice * 100, currencyFormat); // Multiply by 100 to handle cents

  // Check if the user has selected the "subscription" purchase option
  var purchaseOption = $("input[name='purchaseOption']:checked").val();

  if (purchaseOption === "subscription") {
        $(".show-with-subscription-only").show();

 var discount = $('.saving-price-subs').html();

// Check if discount exists and parse the discount value
if (discount) {
  // Extract the numerical value of the discount percentage (e.g., "10%" -> 10)
  var discountPercentage = parseFloat(discount.replace('%', ''));

  // Get the unit price from the custom attribute
  var unitprice = $(".get-price-default").attr("unitprice");

  if (unitprice) {
    // Calculate the discounted price based on the extracted discount percentage
    var discountedUnitPrice = parseFloat(unitprice) * (1 - (discountPercentage / 100)); // Apply discount
    var formattedDiscountedUnitPrice = formatMoney(discountedUnitPrice, currencyFormat);

    // Update the HTML with the discounted price
    $(".cutom-sub-unit").html(`(${formattedDiscountedUnitPrice})`);
  }
}
 else {
      // alert("No unit price available.");
    }
     $(".custom-single-unit").hide();
    $(".cutom-sub-unit").show();
   

    // Update the price gap only if there is a difference
    if (saveprice !== 0) {
      // Find the price gap container
      var priceGapContainer = $(".custom-price-2-wrap");
      $(".custom-price-1-wrap").hide();
      $(".custom-price-2-wrap").show();
      // Clear the current content of the container
      priceGapContainer.empty();

      // Create and append the subscription price element
      var actualPriceElement = $('<span class="price price--highlight price--large"></span>')
        .html(`<span class="visually-hidden">Angebotspreis</span>${formattedSubscriptionPrice}`);
      
      // Create and append the compare price element
      var comparePriceElement = $('<span class="price price--compare"></span>')
        .html(formattedComparePrice);
      
      // Create and append the save price element (if there's a difference)
      var savePriceElement = $('<span class="price price--save"></span>')
        .html("(Du Sparst "+ formattedSavePrice+")");

      // Append all elements to the container
      priceGapContainer.append(comparePriceElement);
      priceGapContainer.append(actualPriceElement);
      priceGapContainer.append(savePriceElement);
    } else {
      // If there is no difference, no need to update the save price
      console.log("No price difference to display.");
    }
  } else {
        $(".show-with-subscription-only").hide();
       $(".custom-single-unit").show();
    $(".cutom-sub-unit").hide();
    // Hide subscription pricing elements if not selected
    $(".custom-price-2-wrap").hide();
    $(".custom-price-1-wrap").show();
  }
}







$(document).ready(function() {
    function checkForElement() {
        if (document.querySelector(".rc-template__button-group")) {
            var subscriptionprice = $(".subscription-radio .price-label").html();
            console.log("subscription-product");
            var divText = $('.subscription-radio .discount-label').text().trim();
            // Split the text into parts based on space
            var parts = divText.split(' ');

            // Extract the first part and update the main div
            $('.subscription-radio .discount-label').text(parts[0]);

            // Create a new div for the second part and append it after the main div
            var secondPartDiv = $('<div class="saving-price-subs">').text(parts.slice(1).join(' '));
            $('.subscription-radio .discount-label').after(secondPartDiv);
            $("body").addClass("subscription-product-active");

            $(".rc-widget").show();

            var purchaseOption = $("input[name='purchaseOption']:checked").val();

            if (purchaseOption === "subscription") {
              print();
                $(".show-with-subscription-only").show();
                $(".recharge-price-custom-inner").html(subscriptionprice);
               // $(".recharge-price-custom").show();
             //   $(".custom-price-gap").show();
            } else {
              print();
                $(".show-with-subscription-only").hide();
                $(".recharge-price-custom").hide();
              //  $(".custom-price-gap").show();
            }

            $("input[name='purchaseOption']").change(function() {
                var purchaseOption = $("input[name='purchaseOption']:checked").val();

                if (purchaseOption === "subscription") {
                  print();
                    $(".show-with-subscription-only").show();
                    $(".recharge-price-custom-inner").html(subscriptionprice);
                    $(".recharge-price-custom").show();
                   // $(".custom-price-gap").show();
                } else {
                  print();
                    $(".show-with-subscription-only").hide();
                    $(".recharge-price-custom").hide();
                 //   $(".custom-price-gap").show();
                }
            });

            return true; // Element found, stop polling
        } else {
            return false; // Element not found, continue polling
        }
    }

    // Polling function
    function pollForElement(maxAttempts, interval) {
        var attempts = 0;
        
        var intervalId = setInterval(function() {
            attempts++;
            if (checkForElement() || attempts >= maxAttempts) {
                clearInterval(intervalId);
            }
        }, interval);
    }

    // Start polling with optimized frequency
    pollForElement(10, 2000); // Check every 2 seconds, up to 20 seconds
});




/* bundle builder */
(function () {
  const dataTotals = document.querySelectorAll("[data-totalstep]");
  const numerOfStepArr = Array.from(dataTotals)
    .filter((el) => el === el.parentElement.lastElementChild)
    .map((el) => el.getAttribute("data-totalstep"));
  const numerOfStep = parseInt(numerOfStepArr[0]);
  function activateAtc() {
    if (numerOfStepArr != dataVidArray.length) {
      $("#AddToCart").attr("disabled", "true");
    } else {
      $("#AddToCart").removeAttr("disabled");
    }
  }
  activateAtc();
  function getActiveItems() {
    dataVidArray.length = 0;
    var bundleSteps = document.querySelectorAll(".bundle-step");
    bundleSteps.forEach(function (bundleStep) {
      var dataVid = bundleStep.getAttribute("data-vid");
      var ptitle = bundleStep.getAttribute("data-ptitle");

      if (dataVid !== "") {
        dataVidArray.push({
          vid: dataVid,
          ptitle: ptitle
        });
      }
    });
  }
  function openBundlePopup(parent) {
    $(parent).find(".bundle-step-popup-overlay").addClass("active");
  }
  function closeBundlePopup() {
    $(".bundle-step-popup-overlay").removeClass("active");
  }
  $(".bundle-builder-wrapper .bundle-step-product-btn svg").click(function (e) {
    e.preventDefault();
    var parent = $(this).parents(".bundle-step");
    openBundlePopup(parent);
  });

  $(
    ".bundle-builder-wrapper .bundle-step-popup .bundle-step-popup-close"
  ).click(function (e) {
    e.preventDefault();
    console.log("yes");
    closeBundlePopup();
  });

  $(".bundle-builder-wrapper .bundle-step-popup-overlay").click(function (
    event
  ) {
    if (event.target === this) {
      closeBundlePopup();
    }
  });

  $(".bundle-builder-wrapper .atc-btn").click(function (e) {
    e.preventDefault();
    closeBundlePopup();
    var vid = $(this).attr("data-vid");
    var ptitle = $(this).attr("data-ptitle");
    var parent = $(this).closest(".bundle-step");
    var currentParent = $(this).closest(".bundle-step-products-product");
    $(parent).attr("data-vid", vid);
      $(parent).attr("data-ptitle", ptitle);
    $(parent).find(".bundle-step-product-img img").removeAttr("srcset");
    var img = $(currentParent) .find(".bundle-step-products-product-img img") .attr("src");
    $(parent)
      .find(".bundle-step-product-img img")
      .attr(
        "src",
        img
      );

    localStorage.setItem(ptitle, img);
    console.log(ptitle);
    console.log(localStorage.getItem(ptitle));

    $(parent)
      .find(".selected_value")
      .text($(currentParent).find(".product-name").text());
    getActiveItems();
    activateAtc();
  });
})();
/* bundle builder */

$(".custom-variant-custom").click(function () {
  $(".custom-variant-custom").removeClass("active"); // Remove active class from all elements
  $(this).addClass("active"); // Add active class to the clicked element
});

$(document).ready(function () {
  $(".has-dropdown").mouseenter(function () {
    const dropdown = $(this).find("[aria-controls]");
    if (dropdown.length > 0) {
      const dropdownId = dropdown.attr("aria-controls");
      const megaMenu = $("#" + dropdownId);
      if (megaMenu.length > 0) {
        megaMenu.removeAttr("hidden");
      }
    }
  });

  $(".has-dropdown").mouseleave(function () {
    const dropdown = $(this).find("[aria-controls]");
    if (dropdown.length > 0) {
      const dropdownId = dropdown.attr("aria-controls");
      const megaMenu = $("#" + dropdownId);
      if (megaMenu.length > 0) {
        megaMenu.attr("hidden", true);
      }
    }
  });
});

$(document).ready(function () {
  // Check on page load
  checkScrollHeight();

  // Throttled scroll event handler for better performance
  let scrollTimeout;
  $(window).scroll(function () {
    if (scrollTimeout) {
      clearTimeout(scrollTimeout);
    }
    scrollTimeout = setTimeout(checkScrollHeight, 16); // ~60fps
  });

  // Function to check scroll height and add classes
  function checkScrollHeight() {
    if ($(window).scrollTop() > 40) {
      $("body").addClass("scroll-over-40");
    } else {
      $("body").removeClass("scroll-over-40");
    }

    if ($(window).scrollTop() > 20) {
      $("body").addClass("scroll-over-24");
    } else {
      $("body").removeClass("scroll-over-24");
    }
  }
});

$("input[name='discount-message']").change(function () {
  getcl = $(this).attr("custom-cl");

  // Get the value of the checked checkbox
  var checkedValue = $("input[name='discount-message']:checked").val();
  $(getcl).prop("disabled", false);
  $(getcl).val(checkedValue);
});
